/**
 * 描述：allTenantManageRouterModule 所有用户管理路由
 * 日期：2019-07-16
 * 作者：Qian.qianchen
 */
"use strict";
angular.module("allTenantManageRouterModule", [
    ])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("manageconfig.tenantmanagement.allTenantManage.tenantDataConfig", { //租户成品数据配置
                url: '/tenantDataConfig?tenantid',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/allTenantManage/tenantDataConfig/tenantDataConfig_tpl.html',
                        controller: 'tenantDataConfigCtrl'
                    }
                }
            }).state("manageconfig.tenantmanagement.allTenantManage.xhsgConfig", {
                url: '/xhsgConfig?tenantid',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/allTenantManage/xhsgConfig/xhsgConfig_tpl.html',
                        controller: 'xhsgConfigCtrl'
                    }
                }
            });
    }]);